import Vue from 'vue';

export const updater = Vue.observable({
  newVersionAvailable: false,
});
if ('serviceWorker' in navigator) {
  // navigator.serviceWorker.addEventListener('statechange', function() {
  //   if (navigator.serviceWorker.state == 'installed') {
  //   }
  // });
  // navigator.serviceWorker.addEventListener('controllerchange', function(event) {
  //   updater.newVersionAvailable = true;
  //   console.log('new version available');
  // });
}